import React from "react"
import { Sticky } from "app/shared/components/sticky"
import ToolbarMenu from "./new-toolbar-menu"
import { useActiveBlock } from "app/regions/hooks/use-active-block"

// NOTE: This file should be replace toolbar-content.js once the new toolbar is fully released
const Overlay = ({ onClick }) => (
  <div
    role="presentation"
    onClick={onClick}
    style={{
      position: "fixed",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      overflow: "auto"
    }}
  />
)

export default React.forwardRef(function Toolbar(
  { arrow, buttons = [], editor, menu, arrowStyle },
  ref
) {
  const { activeBlock } = useActiveBlock()

  const classes =
    activeBlock?.type !== "text" ? "pointer-events-none opacity-25" : ""

  return (
    <>
      {menu.active && <Overlay onClick={menu.close} />}
      <Sticky
        className="bg-white z-10 border-b border-gray-200"
        stuckClasses="shadow-lg"
        unstuckClasses="rounded-t"
      >
        <div
          ref={ref}
          className={`flex items-center transition-opacity duration-100 ${classes}`}
          data-testid="toolbar"
          style={{ padding: 2 }}
        >
          <>
            {buttons.map((button, i) => {
              if (!button) return null
              const Button = button.component
              return (
                <Button
                  is="secondary"
                  key={i}
                  menu={{
                    close: menu.close,
                    open: () => menu.open(i)
                  }}
                />
              )
            })}
          </>
          <div>
            {menu.active && (
              <ToolbarMenu
                component={buttons[menu.index].menu}
                editor={editor}
                close={menu.close}
              />
            )}
          </div>
          {arrowStyle && (
            <div
              ref={arrow}
              style={{ left: arrowStyle.left || 0 }}
              className="selection-toolbar-arrow"
            />
          )}
        </div>
      </Sticky>
    </>
  )
})
